import { UserInfo } from '@hobt/user-domain/src/user/user-info';
import { Result } from 'Feature/Arrears/components/ArrearsInquiryPage/core/Result';
import { ApiClient } from 'Foundation/Api';
import { AuthenticationContextType } from 'Foundation/Authentication';
import { config } from '../../../../../config';

export interface UsersApi {
  get: () => Promise<Result<UserInfo, string>>;
}

export const usersApi = (auth: AuthenticationContextType): UsersApi => {
  const { getWithAuth } = ApiClient(auth, { timeout: 10000 });

  const get = async (): Promise<Result<UserInfo, string>> => {
    try {
      const url = config.userApi.urls.details;
      const response = await getWithAuth(url);
      const userInfo = response.data.data[0] as UserInfo;
      return Result.success(userInfo);
    } catch (error) {
      const apiError = error as any;
      return Result.failure(apiError.response?.data?.error?.errorCode ?? 'unknown-error');
    }
  };

  return { get };
};
